/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */
package systems.frictionless.impulse.browser.style

import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.CSSBorder
import org.jetbrains.compose.web.css.CSSMediaQuery
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.StylePropertyValue
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.and
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.bottom
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.flex
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.gridColumn
import org.jetbrains.compose.web.css.gridRow
import org.jetbrains.compose.web.css.gridTemplateColumns
import org.jetbrains.compose.web.css.gridTemplateRows
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.listStylePosition
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginLeft
import org.jetbrains.compose.web.css.marginRight
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.media
import org.jetbrains.compose.web.css.mediaMaxHeight
import org.jetbrains.compose.web.css.mediaMaxWidth
import org.jetbrains.compose.web.css.mediaMinWidth
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.opacity
import org.jetbrains.compose.web.css.outline
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingBottom
import org.jetbrains.compose.web.css.paddingLeft
import org.jetbrains.compose.web.css.paddingRight
import org.jetbrains.compose.web.css.paddingTop
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.pt
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.transform
import org.jetbrains.compose.web.css.value
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.css.width
import systems.frictionless.impulse.browser.style.constants.AUTO
import systems.frictionless.impulse.browser.style.constants.B
import systems.frictionless.impulse.browser.style.constants.BODY
import systems.frictionless.impulse.browser.style.constants.BUTTON
import systems.frictionless.impulse.browser.style.constants.DESKTOP
import systems.frictionless.impulse.browser.style.constants.FIT_CONTENT
import systems.frictionless.impulse.browser.style.constants.H1
import systems.frictionless.impulse.browser.style.constants.H2
import systems.frictionless.impulse.browser.style.constants.H3
import systems.frictionless.impulse.browser.style.constants.HTML
import systems.frictionless.impulse.browser.style.constants.HTML_ATTR_DISABLED
import systems.frictionless.impulse.browser.style.constants.INHERIT
import systems.frictionless.impulse.browser.style.constants.INPUT
import systems.frictionless.impulse.browser.style.constants.INSIDE
import systems.frictionless.impulse.browser.style.constants.LABEL
import systems.frictionless.impulse.browser.style.constants.LARGE
import systems.frictionless.impulse.browser.style.constants.LARGER
import systems.frictionless.impulse.browser.style.constants.LI
import systems.frictionless.impulse.browser.style.constants.MIN_CONTENT
import systems.frictionless.impulse.browser.style.constants.MOBILE_LANDSCAPE_MAX_HEIGHT
import systems.frictionless.impulse.browser.style.constants.MOZ_FIT_CONTENT
import systems.frictionless.impulse.browser.style.constants.MOZ_USER_SELECT
import systems.frictionless.impulse.browser.style.constants.MS_USER_SELECT
import systems.frictionless.impulse.browser.style.constants.NONE
import systems.frictionless.impulse.browser.style.constants.OL
import systems.frictionless.impulse.browser.style.constants.P
import systems.frictionless.impulse.browser.style.constants.POINTER
import systems.frictionless.impulse.browser.style.constants.SMALLER
import systems.frictionless.impulse.browser.style.constants.TEXTAREA
import systems.frictionless.impulse.browser.style.constants.UNSET
import systems.frictionless.impulse.browser.style.constants.USER_SELECT
import systems.frictionless.impulse.browser.style.constants.WEBKIT_FILL_AVAILABLE
import systems.frictionless.impulse.browser.style.constants.WEBKIT_USER_SELECT
import systems.frictionless.impulse.browser.style.constants.checkMarkHeight
import systems.frictionless.impulse.browser.style.constants.colorBlue
import systems.frictionless.impulse.browser.style.constants.colorCheckmarkCenter
import systems.frictionless.impulse.browser.style.constants.colorCheckmarkChecked
import systems.frictionless.impulse.browser.style.constants.colorCheckmarkHover
import systems.frictionless.impulse.browser.style.constants.colorCheckmarkUnchecked
import systems.frictionless.impulse.browser.style.constants.colorErrorText
import systems.frictionless.impulse.browser.style.constants.colorGray
import systems.frictionless.impulse.browser.style.constants.colorInputBorderFocused
import systems.frictionless.impulse.browser.style.constants.colorInputBorderNormal
import systems.frictionless.impulse.browser.style.constants.colorLightGray
import systems.frictionless.impulse.browser.style.constants.colorProgressBarBackground
import systems.frictionless.impulse.browser.style.constants.colorTabSelectorBackground
import systems.frictionless.impulse.browser.style.constants.colorTabSelectorBorder
import systems.frictionless.impulse.browser.style.constants.colorTabSelectorForeground
import systems.frictionless.impulse.browser.style.constants.colorWhite
import systems.frictionless.impulse.browser.style.constants.fontFamilyHeaders
import systems.frictionless.impulse.browser.style.constants.fontWeightSemiBold
import systems.frictionless.impulse.browser.style.constants.grid0_5
import systems.frictionless.impulse.browser.style.constants.grid1
import systems.frictionless.impulse.browser.style.constants.grid12
import systems.frictionless.impulse.browser.style.constants.grid14
import systems.frictionless.impulse.browser.style.constants.grid18
import systems.frictionless.impulse.browser.style.constants.grid2
import systems.frictionless.impulse.browser.style.constants.grid20
import systems.frictionless.impulse.browser.style.constants.grid3
import systems.frictionless.impulse.browser.style.constants.grid4
import systems.frictionless.impulse.browser.style.constants.grid5
import systems.frictionless.impulse.browser.style.constants.grid6
import systems.frictionless.impulse.browser.style.constants.grid8
import systems.frictionless.impulse.browser.style.constants.inputBorderWidth
import systems.frictionless.impulse.browser.style.constants.navigationListMarginLeft
import systems.frictionless.impulse.browser.style.constants.tabSelectorBorderRadius
import systems.frictionless.impulse.browser.style.support.FontWeight
import systems.frictionless.impulse.browser.style.support.Margin
import systems.frictionless.impulse.browser.style.support.TextAlign
import systems.frictionless.impulse.browser.style.support.borderBottom
import systems.frictionless.impulse.browser.style.support.borderBottomLeftRadius
import systems.frictionless.impulse.browser.style.support.borderBottomRightRadius
import systems.frictionless.impulse.browser.style.support.borderRight
import systems.frictionless.impulse.browser.style.support.borderTop
import systems.frictionless.impulse.browser.style.support.borderTopLeftRadius
import systems.frictionless.impulse.browser.style.support.borderTopRightRadius
import systems.frictionless.impulse.browser.style.support.content
import systems.frictionless.impulse.browser.style.support.fontSize
import systems.frictionless.impulse.browser.style.support.fontWeight
import systems.frictionless.impulse.browser.style.support.gridGap
import systems.frictionless.impulse.browser.style.support.left
import systems.frictionless.impulse.browser.style.support.marginBlockEnd
import systems.frictionless.impulse.browser.style.support.marginBlockStart
import systems.frictionless.impulse.browser.style.support.marginHorizontal
import systems.frictionless.impulse.browser.style.support.marginRight
import systems.frictionless.impulse.browser.style.support.marginVertical
import systems.frictionless.impulse.browser.style.support.placeholder
import systems.frictionless.impulse.browser.style.support.position
import systems.frictionless.impulse.browser.style.support.repeat
import systems.frictionless.impulse.browser.style.support.textAlign
import systems.frictionless.impulse.browser.style.support.top
import systems.frictionless.impulse.browser.style.support.transform
import systems.frictionless.impulse.browser.style.support.width
import systems.frictionless.impulse.browser.style.AppStyleSheetVariables as Vars

@OptIn(ExperimentalComposeWebApi::class)
@Suppress("MagicNumber")
object AppStyleSheet : StyleSheet(usePrefix = false) {
    internal const val ASSETS_PATH = "/asset"
    private const val USE_WHITE_BOX_DESIGN = true

    val contentContainer: String by style {
        display(DisplayStyle.Grid)
        gridTemplateColumns(repeat(cells = 10, flexFactor = 1.fr))
        gridTemplateRows(repeat(cells = 10, flexFactor = 1.fr))
        gridGap(0.px)
        width(100.vw)
        height(100.vh)
        padding(0.px)
    }

    val navigationContainer by style {
        display(DisplayStyle.None)
    }

    val progressContainer by style {
        gridRow(9, 11)
        gridColumn(1, 11)
    }

    val mainContainer by style {
        gridColumn(1, 11)
        gridRow(1, 9)
        padding(grid6)
        maxWidth(90.percent)
        marginHorizontal(Margin.AUTO)
        width(90.percent)
    }

    val navigation by style {
        margin(0.px)
        position(Position.Absolute)
        top(50.percent)
        transform {
            translateY((-50).percent)
        }
    }

    val noProgress by style {}
    val noNavigation by style {}
    val progressBar by style {
        position(Position.Fixed)
        bottom(0.px)
        display(DisplayStyle.LegacyInlineFlex)
        width(100.percent)
        backgroundColor(colorProgressBarBackground)
    }
    val progressOuter by style {}
    val progressInner by style { }

    val formContainer by style {}

    val logo by style {
        display(DisplayStyle.Block)
        marginHorizontal(Margin.AUTO)
    }

    val ignoreCenteringOnMobile by style {
        marginTop(grid6)
    }

    val ignoreCenteringOnMobileLandscape by style {
        marginTop(grid6)
    }

    val centeredOnScreen by style {
        position(Position.Absolute)
        top(50.percent)
        left(50.percent)
        transform {
            translate(
                (-50).percent,
                (-50).percent
            )
        }
        textAlign(TextAlign.CENTER)
        width(90.percent)
    }

    val horizontallyCentered by style {
        marginHorizontal(Margin.AUTO)
    }

    // White box
    val whiteBox by style {}
    val narrowBox by style {}
    val whiteBoxEnabled by style {}
    val fixedSize by style {}
    val addHorizontalPaddingInMobileLandscape by style { }

    val blueButton by style {}

    // Dimensions
    val largeWidth by style {
        maxWidth(Vars.elementWidthLarge.value())
    }
    val mediumWidth by style {
        maxWidth(Vars.elementWidthMedium.value())
    }
    val smallWidth by style {
        maxWidth(Vars.elementWidthSmall.value())
    }

    val fullScreenErrorTextContainer by style {
        paddingBottom(grid4)
    }

    val errorMessage by style {
        color(colorErrorText)
    }

    val selected by style { }

    val list by style {}
    val note by style { }

    // Questions/Demographics related progress
    val progress by style {
        width(MIN_CONTENT)
        marginHorizontal(Margin.AUTO)
        fontSize(Vars.fontSizeNormal.value())
    }

    val progressValue by style { }
    val progressTotal by style { }

    // Sections

    // Intro section specific formatting
    val login by style {
        textAlign(TextAlign.CENTER)
    }
    val intro by style {
        textAlign(TextAlign.CENTER)
        overflowY(AUTO)
    }

    val introList by style {
        marginTop(grid4)
        maxWidth(Vars.elementWidthMedium.value())
        marginHorizontal(Margin.AUTO)
    }

    val introItem by style {
        textAlign(TextAlign.START)
        marginBottom(grid1)
        fontSize(LARGER)
        fontWeight(fontWeightSemiBold)
    }

    val introItemNote by style {
        display(DisplayStyle.Block)
        textAlign(TextAlign.START)
        marginBottom(grid2)
        marginTop(grid2)
        fontSize(SMALLER)
        fontWeight(FontWeight.Number(200))
        lineHeight(150.percent)
    }

    val headerWithNote by style {
        marginBlockEnd(0.px)
    }

    val noteBelowHeader by style {
        fontSize(Vars.fontSizeNormal.value())
        marginBlockStart(0.px)
        marginBlockEnd(2.em)
    }

    val createAssessment by style {
        textAlign(TextAlign.CENTER)
    }

    // Questions
    val question by style {
        paddingTop(grid18)
    }

    val questionTextArea by style {
        marginTop(grid4)
        width(100.percent)
        maxWidth(Vars.elementWidthMedium.value())
        marginHorizontal(Margin.AUTO)
    }

    val questionMultiChoiceBox by style {
        marginVertical(grid6)
        width(FIT_CONTENT)
        width(MOZ_FIT_CONTENT)
        display(DisplayStyle.Block)
        marginHorizontal(Margin.AUTO)
        textAlign(TextAlign.START)
    }

    val questionText by style {
        marginHorizontal(Margin.AUTO)
        maxWidth(Vars.elementWidthLarge.value())
        fontSize(Vars.fontSizeQuestionText.value())
        fontWeight(fontWeightSemiBold)
        textAlign(TextAlign.CENTER)
        lineHeight(110.percent)
        marginTop(grid4)
    }

    val questionHint by style {
        marginHorizontal(Margin.AUTO)
        maxWidth(Vars.elementWidthLarge.value())
        textAlign(TextAlign.CENTER)
        marginTop(grid4)
        fontSize(Vars.fontSizeQuestionHintText.value())
        lineHeight(110.percent)
    }

    val singleChoiceContainer by style {
        marginRight(grid4)
    }

    val singleChoice by style {
        display(DisplayStyle.Block)
        position(Position.Relative)
        paddingLeft(grid8)
        marginBottom(grid3)
        cursor(POINTER)
        fontSize(Vars.fontSizeNormal.value())
        property(WEBKIT_USER_SELECT, NONE)
        property(MOZ_USER_SELECT, NONE)
        property(MS_USER_SELECT, NONE)
        property(USER_SELECT, NONE)
    }

    val checkMark by style {}

    // Demographics
    val demographics by style {}

    // Insights
    val insights by style {}
    val tabs by style {}
    val tabName by style {}

    val insightTexts by style { }
    val insightsSection by style { }

    init {
        // CSS shared for all screen dimensions
        root style {
            Vars.apply {
                fontSizeNormal(12.pt)
                fontSizeSmall(10.pt)
                fontSizeHeader(22.pt)
                fontSizeTextAreaPlaceholder(10.pt)
                fontSizeLoginFormHeader(28.px)
                fontSizeTextArea(14.pt)
                elementWidthLarge(800.px)
                elementWidthMedium(400.px)
                elementWidthSmall(300.px)
            }
        }

        type(HTML) style {
            minHeight(WEBKIT_FILL_AVAILABLE)
            height(100.percent)
        }

        type(BODY) style {
            fontFamily(*systems.frictionless.impulse.browser.style.constants.fontFamily)
            margin(0.px)
            padding(0.px)
            height(100.percent)
            minHeight(100.vh)
            minHeight(WEBKIT_FILL_AVAILABLE)
        }

        group(type(H1), type(H2), type(H3)) style {
            fontFamily(*fontFamilyHeaders)
        }

        type(H1) style {
            fontSize(Vars.fontSizeHeader.value())
        }

        type(P) style {
            fontSize(Vars.fontSizeNormal.value())
            lineHeight(125.percent)
            marginBlockStart(0.5.em)
            marginBlockEnd(0.5.em)
        }

        type(TEXTAREA) style {
            border {
                width(inputBorderWidth)
                style = LineStyle.Solid
                color = colorInputBorderNormal
            }
            borderRadius(grid2)
        }

        type(TEXTAREA) + focus style {
            border {
                width(inputBorderWidth)
                style = LineStyle.Solid
                color = colorInputBorderFocused
            }
            outline(NONE)
        }

        type(TEXTAREA) + placeholder style {
            fontSize(Vars.fontSizeTextAreaPlaceholder.value())
        }

        desc(combine(className(contentContainer), className(noProgress)), className(progressContainer)) style {
            display(DisplayStyle.None)
        }

        desc(combine(className(contentContainer), className(noProgress)), className(mainContainer)) style {
            gridRow(1, 11)
        }

        // Navigation area on the left side
        desc(className(navigation), type(OL)) style {
            marginLeft(navigationListMarginLeft)
            listStylePosition(INSIDE)
        }

        desc(className(navigation), desc(type(OL), type(LI))) style {
            marginBottom(grid3)
            fontSize(LARGE)
        }

        desc(
            className(navigation),
            desc(
                type(OL),
                combine(type(LI), className(selected))
            )
        ) style {
            fontWeight(FontWeight.Bold)
        }

        // Question/demographics related progress
        desc(className(progress), className(progressValue)) style {
            fontWeight(FontWeight.Bold)
        }

        desc(className(progress), className(progressTotal)) style {
            fontWeight(FontWeight.Bold)
            color(colorGray)
        }

        // Progress bar at the bottom

        desc(className(progressBar), type(BUTTON)) style {
            borderRadius(grid2)
            paddingTop(0.px)
            paddingBottom(0.px)
            paddingLeft(grid4)
            paddingRight(grid4)
            padding(0.px)
            fontSize(LARGE)
        }

        desc(className(progressBar), className(progressOuter)) style {
            width(INHERIT)
            marginLeft(grid2)
            marginRight(Margin.AUTO)
            marginVertical(Margin.AUTO)
            height(grid2)
            backgroundColor(colorWhite)
            border {
                width = 1.px
                style = LineStyle.Solid
                color = colorLightGray
            }
        }

        desc(className(progressBar), className(progressInner)) style {
            width(10.percent)
            marginLeft(0.px)
            marginRight(Margin.AUTO)
            marginVertical(Margin.AUTO)
            height(grid2)
            backgroundColor(colorBlue)
        }

        combine(className(centeredOnScreen), className(ignoreCenteringOnMobile)) style {
            position(UNSET)
            top(UNSET)
            left(UNSET)
            transform(UNSET)
            textAlign(TextAlign.CENTER)
            marginHorizontal(Margin.AUTO)
        }

        type(INPUT) style {
            maxWidth(Vars.elementWidthSmall.value())
            margin(grid2)
            fontFamily(*systems.frictionless.impulse.browser.style.constants.fontFamily)
        }

        type(BUTTON) + className(blueButton) style {
            width(75.percent)
            maxWidth(Vars.elementWidthSmall.value())
            borderRadius(grid2)
            border {
                width = 2.px
                style = LineStyle.Solid
                color = colorBlue
            }
            backgroundColor(colorBlue)
            color(colorWhite)
            padding(grid4)
            margin(grid2)
            fontSize(Vars.fontSizeNormal.value())
        }

        group(
            combine(
                type(BUTTON),
                className(blueButton),
                disabled
            ),
            className(blueButton) + attr(HTML_ATTR_DISABLED)
        ) style {
            backgroundColor(colorGray)
            border {
                width = 2.px
                style = LineStyle.Solid
                color = colorGray
            }
        }

        // Login screen

        desc(className(formContainer), type(H1)) style {
            fontSize(Vars.fontSizeLoginFormHeader.value())
        }

        desc(className(intro), type(H3)) style {
            marginTop(grid12)
        }

        desc(className(intro), type(list)) style {
            marginTop(grid4)
            maxWidth(Vars.elementWidthMedium.value())
            marginHorizontal(Margin.AUTO)
        }

        desc(className(login), type(INPUT)) style {
            width(Vars.elementWidthSmall.value() - 2 * grid4)
            borderRadius(grid2)
            border {
                width(inputBorderWidth)
                style = LineStyle.Solid
                color = colorInputBorderNormal
            }
            padding(grid4)
            marginBottom(grid2)
            fontSize(16.pt)
            fontWeight(FontWeight.Number(900))
            textAlign(TextAlign.START)
        }

        desc(className(login), className(blueButton)) style {
            width(Vars.elementWidthSmall.value())
        }

        desc(className(login), combine(type(INPUT), focus)) style {
            border {
                width(inputBorderWidth)
                style = LineStyle.Solid
                color = colorInputBorderFocused
            }
            outline(NONE)
        }

        desc(className(singleChoice), type(INPUT)) style {
            width(MIN_CONTENT)
            marginHorizontal(Margin.AUTO)
            position(Position.Absolute)
            opacity(0)
            cursor(POINTER)
        }

        desc(className(singleChoice), type(LABEL)) style {
            display(DisplayStyle.Block)
            marginTop(grid2)
            fontWeight(FontWeight.Bold)
        }

        // Create a custom radio button
        desc(className(singleChoice), className(checkMark)) style {
            position(Position.Absolute)
            top(0.px)
            left(0.px)
            height(checkMarkHeight)
            width(grid6)
            backgroundColor(colorCheckmarkUnchecked)
            borderRadius(50.percent)
        }

        // On mouse-over, add a grey background color
        desc(
            combine(className(singleChoice), hover),
            sibling(type(INPUT), className(checkMark))
        ) style {
            backgroundColor(colorCheckmarkHover)
        }

        desc(
            className(singleChoice),
            combine(
                sibling(type(INPUT), className(checkMark)),
                after
            )
        ) style {
            display(DisplayStyle.Block)
            top(grid0_5)
            left(grid0_5)
            width(grid5)
            height(grid5)
            borderRadius(50.percent)
            backgroundColor(colorCheckmarkCenter)
        }

        desc(
            className(singleChoice),
            combine(
                sibling(combine(type(INPUT), checked), className(checkMark)),
                after
            )
        ) style {
            top(grid2)
            left(grid2)
            width(grid2)
            height(grid2)
            // may not be necessary v
            borderRadius(50.percent)
            backgroundColor(colorCheckmarkCenter)
            display(DisplayStyle.Block)
        }

        desc(
            className(singleChoice),
            sibling(combine(type(INPUT), checked), className(checkMark))
        ) style {
            backgroundColor(colorCheckmarkChecked)
        }

        combine(className(checkMark), after) style {
            content("")
            position(Position.Absolute)
            display(DisplayStyle.None)
        }

        desc(className(questionTextArea), type(TEXTAREA)) style {
            width(90.percent)
            maxWidth(Vars.elementWidthMedium.value())
            height(grid14)
            padding(grid2)
            fontFamily(*systems.frictionless.impulse.browser.style.constants.fontFamily)
            fontSize(Vars.fontSizeTextArea.value())
        }

        // Demographics tweaks

        desc(className(demographics), className(questionMultiChoiceBox)) style {
            display(DisplayStyle.Block)
        }

        desc(desc(className(demographics), className(questionMultiChoiceBox)), className(singleChoice)) style {
            textAlign(TextAlign.START)
            flex(UNSET)
            display(DisplayStyle.Block)
            maxWidth(Vars.elementWidthLarge.value())
        }

        desc(
            desc(desc(className(demographics), className(questionMultiChoiceBox)), className(singleChoice)),
            type(LABEL)
        ) style {
            display(DisplayStyle.Inline)
            marginLeft(grid4)
        }

        // Insights screen

        desc(className(insights), type(H1)) style {
            fontWeight(FontWeight.Number(500))
            fontSize(32.px)
            marginBlockEnd(0.px)
            marginBlockStart(0.px)
            marginBottom(0.px)
        }

        desc(desc(className(insights), type(H1)), type(B)) style {
            fontWeight(FontWeight.Bold)
        }

        desc(className(insights), className(tabs)) style {
            marginTop(grid6)
            // Hack to prevent Tap To Search feature of Chrome for Android
            property(WEBKIT_USER_SELECT, NONE)
        }

        val tabSelectorBorder: CSSBorder.() -> Unit = {
            width = 1.px
            style = LineStyle.Solid
            color(colorTabSelectorBorder)
        }

        desc(desc(className(insights), className(tabs)), className(tabName)) style {
            display(DisplayStyle.Inline)
            paddingRight(grid6)
            fontSize(Vars.fontSizeSmall.value())
            padding(grid2)
            cursor(POINTER)
            borderTop(tabSelectorBorder)
            borderBottom(tabSelectorBorder)
        }

        desc(desc(className(insights), className(tabs)), combine(className(tabName), className(selected))) style {
            backgroundColor(colorTabSelectorBackground)
            border {
                color = colorTabSelectorBackground
            }
            color(colorTabSelectorForeground)
        }

        desc(
            desc(className(insights), className(tabs)),
            combine(className(tabName), not(firstChild), not(lastChild))
        ) style {
            borderRight(tabSelectorBorder)
        }

        desc(desc(className(insights), className(tabs)), combine(className(tabName), firstChild)) style {
            border(tabSelectorBorder)
            borderTopLeftRadius(tabSelectorBorderRadius)
            borderBottomLeftRadius(tabSelectorBorderRadius)
        }

        desc(
            desc(className(insights), className(tabs)),
            combine(className(tabName), className(selected), firstChild)
        ) style {
            border(tabSelectorBorder)
        }

        desc(desc(className(insights), className(tabs)), combine(className(tabName), lastChild)) style {
            borderRight(tabSelectorBorder)
            borderTopRightRadius(tabSelectorBorderRadius)
            borderBottomRightRadius(tabSelectorBorderRadius)
        }

        desc(
            desc(className(insights), className(tabs)),
            combine(className(tabName), className(selected), lastChild)
        ) style {
            borderRight(tabSelectorBorder)
        }

        desc(className(insights), className(insightTexts)) style {
            height(100.vh - 140.px)
            overflowY(AUTO)
            marginTop(grid4)
        }

        desc(
            desc(className(insights), className(insightTexts)),
            className(insightsSection)
        ) style {
            paddingBottom(grid6)
        }

        desc(
            desc(className(insights), className(insightTexts)),
            combine(className(insightsSection), lastChild)
        ) style {
            paddingBottom(grid20)
        }

        // Desktop related tweaks
        val mediaTypeScreen = CSSMediaQuery.MediaType(CSSMediaQuery.MediaType.Enum.Screen)
        val screenWidthDesktop: CSSMediaQuery.MediaFeature = mediaMinWidth(DESKTOP)

        media(mediaTypeScreen.and(screenWidthDesktop)) {
            desktopDesign(this)
        }

        if (USE_WHITE_BOX_DESIGN) {
            media(mediaTypeScreen.and(screenWidthDesktop)) {
                whiteBoxDesign(this)
            }
        }

        // Printing support
        val mediaTypePrint = CSSMediaQuery.MediaType(CSSMediaQuery.MediaType.Enum.Print)
        media(mediaTypePrint) {
            formattingForPrinting(this)
        }

        // Mobile phone landscape
        val mobileLandscapeMaxHeight: CSSMediaQuery.MediaFeature = mediaMaxHeight(MOBILE_LANDSCAPE_MAX_HEIGHT)
        val orientationLandscape: CSSMediaQuery.MediaFeature =
            CSSMediaQuery.MediaFeature("orientation", StylePropertyValue("landscape"))
        media(mediaTypeScreen.and(mobileLandscapeMaxHeight).and(orientationLandscape)) {
            mobilePhoneLandscape(this)
        }

        // Small phones like iPhone SE
        val smallDeviceMinWidth = mediaMinWidth(320.px)
        val smallDeviceMaxWidth = mediaMaxWidth(480.px)
        val smallDevicePixelRatio =
            CSSMediaQuery.MediaFeature("-webkit-min-device-pixel-ratio", StylePropertyValue("2"))
        media(mediaTypeScreen.and(smallDeviceMinWidth).and(smallDeviceMaxWidth).and(smallDevicePixelRatio)) {
            smallMobilePhone(this)
        }
    }
}
